import { render, staticRenderFns } from "./RecommendMock.vue?vue&type=template&id=5c8345e5&"
import script from "./RecommendMock.vue?vue&type=script&lang=js&"
export * from "./RecommendMock.vue?vue&type=script&lang=js&"
import style0 from "./RecommendMock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports